module.exports = require('../dist/compat/string/lowerFirst.js').lowerFirst;
